"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var TripDestinationComponent = (function () {
    // expand sections
    function TripDestinationComponent() {
        this.states = [];
        this.messages = {
            'destination': {
                'required': 'Destination Country is required.'
            },
            'destinationState': {
                'required': 'Destination State is required.'
            }
        };
    }
    return TripDestinationComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", forms_1.FormGroup)
], TripDestinationComponent.prototype, "form", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], TripDestinationComponent.prototype, "submitted", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], TripDestinationComponent.prototype, "showDivider", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], TripDestinationComponent.prototype, "states", void 0);
TripDestinationComponent = __decorate([
    core_1.Component({
        selector: 'trip-destination',
        template: "<div class=\"row\">     <div class=\"col-md-12\">         <h4 class=\"pull-left\">Trip</h4>     </div> </div> <div class=\"row\" [formGroup]=\"form\">     <div class=\"form-group col-sm-6 col-md-4\">         <label>Country</label>         <typeahead-country placeHolder=\"Country\" [allowGarbage]=\"true\" formControlName=\"destination\"></typeahead-country>         <validation-messages [control]=\"form.controls.destination\"                              [messages]=\"messages.destination\"                              [submitted]=\"submitted\"></validation-messages>     </div>     <div *ngIf=\"form.controls.destinationState\" class=\"form-group col-sm-6 col-md-4\">         <label>State</label>         <select class=\"form-control traveler-detail-residence\" formControlName=\"destinationState\">             <option value=\"\">Select</option>             <option *ngFor=\"let state of states\" value=\"{{state.isoCode2}}\">{{state.name}}</option>         </select>         <validation-messages [control]=\"form.controls.destinationState\"                              [messages]=\"messages.destinationState\"                              [submitted]=\"submitted\"></validation-messages>     </div>     <div *ngIf=\"form.controls.destinationCity\" class=\"form-group col-sm-6 col-md-4\">         <label>City</label>         <input type=\"text\" class=\"form-control\" placeholder=\"optional\" formControlName=\"destinationCity\" />     </div> </div> <hr *ngIf=\"showDivider\" />"
    }),
    __metadata("design:paramtypes", [])
], TripDestinationComponent);
exports.TripDestinationComponent = TripDestinationComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/trip-details/trip-destination.component.js